// src/pages/Trailers.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import '../styles/Trailers.css';
import moviesData from "../data/movies.json";
import { slugify } from "../components/utils";


function convertDuration(durationStr) {
  if (!durationStr || durationStr.trim() === '') {
    return '';
  }
  const minutes = parseInt(durationStr, 10);
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return remainingMinutes ? `${hours}h ${remainingMinutes} min` : `${hours}h`;
  }
  return `${minutes} min`;
}

const Trailers = () => {
  const [selectedGenre, setSelectedGenre] = useState('Tous');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // Extraction des genres uniques
  const allGenres = moviesData.reduce((acc, movie) => {
    movie.genre.forEach(g => {
      if (!acc.includes(g)) {
        acc.push(g);
      }
    });
    return acc;
  }, []);
  const genres = ['Tous', ...allGenres.sort()];

  // Filtrer les films ayant une bande-annonce
  const trailers = moviesData.filter(movie => movie.bande_annonce);

  // Filtrer par genre sélectionné
  const filteredTrailers = trailers.filter(movie =>
    selectedGenre === 'Tous' || movie.genre.includes(selectedGenre)
  );

  // Pagination
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const displayedTrailers = filteredTrailers.slice(indexOfFirst, indexOfLast);

  const handleNext = () => {
    if (indexOfLast < filteredTrailers.length) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  // Réinitialise la pagination quand le genre change
  const handleGenreChange = (genre) => {
    setSelectedGenre(genre);
    setCurrentPage(1);
  };

  return (
    <div className="trailers-page">
      <h1 className="page-title">Bandes-annonces</h1>

      <div className="genre-filter">
        {genres.map(genre => (
          <button
            key={genre}
            className={selectedGenre === genre ? 'active' : ''}
            onClick={() => handleGenreChange(genre)}
          >
            {genre}
          </button>
        ))}
      </div>

      <div className="trailers-grid">
        {displayedTrailers.map(movie => (
          <motion.div
            key={movie.id}
            className="trailer-card"
            whileHover={{ scale: 1.02 }}
          >
            <div className="video-wrapper">
              <iframe
                src={movie.bande_annonce}
                title={movie.titre}
                allowFullScreen
              ></iframe>
            </div>
            <div className="trailer-info">
              <Link to={`/film/${slugify(movie.titre)}`}>
                <h3>{movie.titre}</h3>
                <div className="meta">
                  <span className="genre">{movie.genre.join(', ')}</span>
                  <span className="duration">{convertDuration(movie.runtime)}</span>
                </div>
              </Link>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="pagination-controls">
        {currentPage > 1 && (
          <button className="pagination-button" onClick={handlePrev}>
            Précédent
          </button>
        )}
        {indexOfLast < filteredTrailers.length && (
          <button className="pagination-button" onClick={handleNext}>
            Suivant
          </button>
        )}
      </div>
    </div>
  );
};

export default Trailers;
